/**
 * Detector Style01 - Detected / Not detected display (read-only)
 */
import type { TraitControlProps } from './types'

export function DetectorStyle01({ state }: TraitControlProps) {
  const raw = state?.detected ?? state?.value ?? state?.status
  const str = String(raw ?? '').toLowerCase()
  const isDetected = raw === true || str === 'detected' || str === 'true'

  return (
    <div className="smart-home-automation-field">
      <label>Detector</label>
      <div className="smart-home-automation-command-row">
        <span className={`material-symbols-outlined ${isDetected ? 'text-green-400' : ''}`}>
          {isDetected ? 'motion_photos_on' : 'motion_photos_off'}
        </span>
        <span className="trait-detector-style01__value">{isDetected ? 'Detected' : 'Not detected'}</span>
      </div>
    </div>
  )
}
